import React, { useEffect, useState }from "react";
import { Modal, Select, Spin, notification } from "antd";
import _ from 'lodash';
import styled from "styled-components";
import { Icon } from 'dlweb-components';
import UserPicker from "../../UserPicker";

const WorkflowReplacementPicker = ({ visible, onOk, onCancel, onSelect, membersInWorkflow, userIds, includeGroups = false }) => {
  
  const [disabled, setDisabled] = useState(true)
  const [selectedUsers, setSelectedUsers] = useState([])

  useEffect(() => {
    setDisabled(true)
  }, [visible])

  const onChange = (selectedUser) => {
    console.log('selectedUser', selectedUser)
    setSelectedUsers(selectedUser)
    onSelect(selectedUser);
    setDisabled(false);
  }

  const onClose = () => {
    console.log('onClose')
    setSelectedUsers([])
  }

  return (
    <Modal
      open={visible}
      onOk={onOk}
      onCancel={onCancel}
      width={575}
      afterClose={onClose}
      destroyOnClose={true}
      maskClosable={false}
      okButtonProps={{disabled: disabled}}
      title={<>
                <Icon type='exclamation-circle' size="lg" style={{color: 'var(--warning-color)', marginRight: '10px'}}/>
                Please select replacement
            </>}
    >
			<div>
				<span>
          {`The following ${includeGroups ? 'groups' : 'users'} are participants in a workflow process or an event subscription:`}
        <UserList>
          {membersInWorkflow.map(i => (
              <div key={i}>{i}</div>
            ))
          }
        </UserList>
          {`Please select a replacement user ${includeGroups ? 'or group' : ''} before continuing.`}
				</span>
        <UserPicker
          multiSelect={false}
          onChange={onChange}
          blacklist={userIds}
          value={selectedUsers}
          restrictUsers={false}
          includeGroups={includeGroups}
        />
			</div>
    </Modal>
  );
};

const UserList = styled.div`
  margin: 10px 0;
  font-weight: bold;
  max-height: 100px;
  overflow-y: auto;
`

export default WorkflowReplacementPicker;
